import React, { useRef, useState, useContext, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { getPersonalityData } from 'services/break.js'
import ListicleVoteButtons from './ListicleVoteButtons'
import Slider from 'react-slick'
// import ArrowButton from "images/inline/arrow-right.svg"
import ArrowButton from 'steps/ArrowButton'

import StartSlideWrapper from 'steps/StartSlideWrapper'
import SkipButton from 'steps/SkipButton'

import { userContext } from 'global/context/sub-contexts/userContext'

import {
  start as serviceStart,
  complete as serviceComplete,
} from 'services/listicle'
import analytics from 'global/AnalyticsData'

import './listicle.scss'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const ListicleStep = ({
  breakId,
  step,
  onGoToNext,
  onStepStart,
  onStepComplete,
  onStepSkip,
  isEmbed,
  unlockNextStep,
  scrollComplete,
  isComplete,
  onAuthRequired,
  onUnhandledError,
  HtmlFooter,
  parentSliderRef,
}) => {
  const [listItems, setListItems] = useState(step.listicle.items)
  const [stepSkipped, setStepSkipped] = useState(false)
  const [arrowDisabled, setArrowDisabled] = useState(true)
  const [skipVisible, setSkipVisible] = useState(step.showSkipButton)
  console.log(parentSliderRef)

  const user_context = useContext(userContext)
  const { isLoggedIn } = user_context || {}

  // console.log(step)

  //state funcs converted to ref funcs
  const sectionEl = useRef(null)
  const nextArrowEl = useRef(null)
  const skipBtnEl = useRef(null)

  const setWaitingForServer = state => {
    if (state === true) {
      sectionEl.current.classList.remove('waiting-false')
      sectionEl.current.classList.add('waiting-true')
    } else {
      sectionEl.current.classList.remove('waiting-true')
      sectionEl.current.classList.add('waiting-false')
    }
  }
  const setArrowUnlocked = () => {
    // nextArrowEl.current.disabled = false;
  }

  const setArrowVisibility = state => {
    setTimeout(() => {
      if (state === true) {
        // nextArrowEl.current.style.display = 'block';
      } else {
        // nextArrowEl.current.style.display = 'none';
      }
    }, 500)
    //500 matches slide transition time
  }

  useEffect(() => {
    if (isLoggedIn) {
      getPersonalityQuizResultId()
    }
  }, [isLoggedIn])

  useEffect(() => {
    if (!step.hasStartScreen) {
      handleStartClick()
    } else {
      setArrowVisibility(false)
    }
  }, [])

  //listen for scrollComplete and fire off handleCompleteClick when toggled
  useEffect(() => {
    if (scrollComplete) {
      setArrowDisabled(false)
      handleCompleteClick()
    }
  }, [scrollComplete])

  var settings = {
    dots: false,
    arrows: false,
    swipe: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    touchMove: false,
    adaptiveHeight: false,
    slidesToScroll: 1,
    variableWidth: false,
    beforeChange: function (currentSlide, nextSlide) {
      if (sliderRef && sliderRef.current && sliderRef.current.innerSlider) {
        console.log('on before chage')
        sliderRef.current.innerSlider.adaptHeight()
      }
    },
  }
  const sliderRef = useRef(null)

  const handleStartClick = async () => {
    setWaitingForServer(true)
    setArrowVisibility(true)

    try {
      const result = await serviceStart(breakId, step.id)
      if (onStepStart) {
        onStepStart(step, breakId, result.detail.attempt)
      }
      console.log('listicle start')
    } catch (e) {
      console.log(e)
      setWaitingForServer(false)
      if (e.message === '401') {
        onAuthRequired && onAuthRequired()
        // } else {
        // onUnhandledError && onUnhandledError()
      }
      return false
    }

    sliderRef.current.slickNext()

    setWaitingForServer(false)
  }

  const handleStartSlideClick = async () => {
    try {
      const result = await serviceStart(breakId, step.id)
      if (onStepStart) {
        onStepStart(step, breakId, result.detail.attempt)
      }
      console.log('listicle start')
    } catch (e) {
      console.log(e)
      setWaitingForServer(false)
      if (e.message === '401') {
        onAuthRequired && onAuthRequired()
        // } else {
        // onUnhandledError && onUnhandledError()
      }
      return false
    }
  }

  const handleNextClick = () => {
    if (typeof window !== `undefined`) {
      window.dataLayer.push({
        event: 'step_interaction_listicle_arrow_click',
      })

      analytics.stepEvent('step_interaction_listicle_arrow_click', step, {})
    }
    unlockNextStep(step.id)
    setArrowDisabled(false)

    setSkipVisible(false)
    if (skipBtnEl && skipBtnEl.current) {
      skipBtnEl.current.visible = false
    }

    sliderRef.current.slickNext()
  }

  const handlePrevClick = () => {
    if (typeof window !== `undefined`) {
      window.dataLayer.push({
        event: 'step_interaction_listicle_arrow_click',
      })

      analytics.stepEvent('step_interaction_listicle_arrow_click', step, {})
    }
    sliderRef.current.slickPrev()
  }

  const handleCompleteClick = async () => {
    setWaitingForServer(true)

    try {
      const completeResult = await serviceComplete(
        breakId,
        step.id,
        stepSkipped,
      )
      setWaitingForServer(false)
      const { totalPoints } = completeResult.detail
      user_context.setPoints(totalPoints)
      // setSelectedItemIndex()
      console.log('complete: ', completeResult)
      // setStepState('COMPLETE')
      onStepComplete && onStepComplete(step.id)
      onGoToNext && onGoToNext(step.id)
      setArrowDisabled(false)
    } catch (e) {
      setWaitingForServer(false)
      console.log('Complete error')
      console.log(e)
    }
  }

  const handleStepSkip = () => {
    onStepSkip(step.id)
    setStepSkipped(true)
  }

  const getPersonalityQuizResultId = async () => {
    try {
      const response = await getPersonalityData(breakId)
      const pqResultId = response.detail.resultId
      //filter listicle items based on pqresultid
      const newListicleItems = step.listicle.items.filter(item => {
        const hide =
          item.dynamics &&
          item.dynamics.some(dynamic => dynamic.value === pqResultId)
        if (hide) {
          return false
        }
        return true
      })
      if (newListicleItems.length != step.listicle.items.length) {
        setListItems(newListicleItems)
      }
    } catch (e) {
      console.log(e)
      // if (e.message === '401') {
      //   user_context.unauthorized()
      //   askToLogin()
      // } else {
      //   // toggleError(true);
      // }
    }
  }

  const renderContents = (item, content, i) => {
    switch (content.type) {
      case 'Image': {
        return (
          <div className="image-contain" key={content['id']}>
            {content.image && content.image.id && (
              <img
                src={`${process.env.SITE_ASSET_URL}/${content.image.id}`}
                // width={content.imageType === "VERTICAL" ? 228 : 425}
                // height={content.imageType === "VERTICAL" ? 425 : 228}
                className="todo"
                alt=""
              />
            )}
          </div>
        )
      }
      case 'BodyCopy': {
        return (
          <div className="body-copy" key={content['id']}>
            <p dangerouslySetInnerHTML={{ __html: content.bodyCopy }} />
            {content.hasVoting && (
              <div className="voting">
                <ListicleVoteButtons
                  listicleId={step.listicle.id}
                  itemId={content['id']}
                  upVotetxt={item.upvoteBtnText}
                  downVotetxt={item.downvoteBtnText}
                />
              </div>
            )}
          </div>
        )
      }
      case 'Button': {
        return (
          <a
            key={content['id']}
            href={content.url}
            className="shop-button"
            style={{
              background: content.bgColor,
              color: '#fff',
            }}
            target="_blank"
            rel="noopener noreferrer"
            onClick={e => {
              if (typeof window !== `undefined`) {
                window.dataLayer.push({
                  event: 'step_interaction_listicle_button_click',
                })

                analytics.stepEvent(
                  'step_interaction_listicle_button_click',
                  step,
                  {
                    result_id: content.id,
                    result: content.buttonText + ' | ' + content.url,
                  },
                )
              }
            }}
          >
            {content.buttonText}
          </a>
        )
      }
      case 'Subhead': {
        return <h2>{content.content}</h2>
      }
      default:
        return <p>Unhandled: {content.type} </p>
    }
  }

  const ListItem = ({
    item,
    i,
    currentPosition,
    totalItems,
    backgroundImage,
  }) => {
    return (
      <div className="listicle-step__item">
        <div className="container">
          <Grid container justify="center" spacing={2}>
            <div
              className={`listicle-item step-content${
                backgroundImage ? ' bg-img' : ''
              }`}
              key={item.subhead}
            >
              <div className="quiz__progress">
                <span className="quiz__progress-number">
                  {currentPosition} of {totalItems}
                </span>
                <ul className="quiz__progress-dots">
                  {Array.from({ length: totalItems }).map((_, i) => {
                    return (
                      <li
                        key={i}
                        className={`${
                          i + 1 === currentPosition ? 'active' : ''
                        }`}
                      ></li>
                    )
                  })}
                </ul>
                <ul className="inner-arrows">
                  <li>
                    <button
                      type="button"
                      className={`inner-prev`}
                      disabled={currentPosition === 1}
                      onClick={handlePrevClick}
                      aria-label="Previous"
                    ></button>
                  </li>
                  <li>
                    <button
                      type="button"
                      className={`inner-next`}
                      disabled={currentPosition === totalItems}
                      onClick={handleNextClick}
                      aria-label="Next"
                    ></button>
                  </li>
                </ul>
              </div>
              {item.subhead && (
                <h2
                  className="step-content__title"
                  dangerouslySetInnerHTML={{
                    __html: `${i + 1}. ${item.subhead}`,
                  }}
                />
              )}

              {item.listicleContents && (
                <div
                  className={`listicle-item-contents step-content__details ${
                    item.listicleContents.filter(
                      item => item.imageType === 'HORIZONTAL',
                    ).length > 0
                      ? 'horizontal'
                      : 'vertical'
                  }`}
                >
                  {/* non button items */}
                  {item.listicleContents
                    .filter(content => content.type !== 'Button')
                    .map((content, i) => {
                      return renderContents(item, content, i)
                    })}
                  {/* button items */}
                  <div className="shop-buttons">
                    {item.listicleContents
                      .filter(content => content.type === 'Button')
                      .map((content, i) => {
                        return renderContents(item, content, i)
                      })}
                  </div>
                </div>
              )}
            </div>
          </Grid>
          <div className="sponsored-flow-panel--footer">
            <ArrowButton
              ref={nextArrowEl}
              onClick={handleCompleteClick}
              disabled={arrowDisabled}
            />
            {skipVisible && (
              <span ref={skipBtnEl}>
                <SkipButton onClick={handleStepSkip} step_id={step.id} />
              </span>
            )}
          </div>

          {HtmlFooter && <HtmlFooter />}
        </div>
      </div>
    )
  }

  let style = {}

  const bgImg = step && step.backgroundImage && step.backgroundImage.id

  if (step && step.backgroundColor) {
    style.backgroundColor = step.backgroundColor
  }

  if (bgImg) {
    style.backgroundImage = `url(${process.env.SITE_ASSET_URL}/${bgImg})`
  }

  return (
    <div className="sponsored-flow-panel" style={style}>
      <section ref={sectionEl} className={`listicle-step waiting-false`}>
        {/* TODO: omitting breakFooterHTML={this.props.brk.footerHtml} prop */}
        <StartSlideWrapper
          step={step}
          handleStartSlideClick={handleStartSlideClick}
        >
          <Slider {...settings} ref={slider => (sliderRef.current = slider)}>
            {listItems &&
              listItems.map((x, i) => {
                return (
                  <ListItem
                    key={i}
                    item={x}
                    i={i}
                    currentPosition={i + 1}
                    totalItems={listItems.length}
                    backgroundImage={step.backgroundImage}
                  />
                )
              })}
          </Slider>
        </StartSlideWrapper>
      </section>
    </div>
  )
}

export default ListicleStep
